// @flow strict
/* eslint-disable ta-code-conventions/has-matching-storydoc,ta-code-conventions/has-matching-test */
// See https://jira.tamg.io/browse/WP-2462
import * as React from 'react';
import classnames from '@ta/common.classnames';
import styles from './ContainerSheet.css';

type Props = {|
  /**
   * If true, the background is transparent. Defaults to white
   */
  transparentBackground?: boolean,
  /**
   * The content node to render
   */
  children?: React.Node,
|};

/**
 * Renders a blank white sheet to hold content
 */
const ContainerSheet = ({ transparentBackground, children }: Props) => (
  <div className={classnames(styles.container, { [styles.transparent]: transparentBackground })}>
    {children}
  </div>
);

export default ContainerSheet;
